import React, { useRef } from "react";
import QRCode from "react-qr-code";

export default function QRWithLogo({ value }) {
  const qrRef = useRef(null);

  const downloadQR = () => {
    const svg = qrRef.current.querySelector("svg");
    const serializer = new XMLSerializer();
    const svgStr = serializer.serializeToString(svg);

    const canvas = document.createElement("canvas");
    const size = 500;
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext("2d");

    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, size, size);

    const img = new Image();
    img.src = "data:image/svg+xml;base64," + window.btoa(svgStr);

    img.onload = () => {
      ctx.drawImage(img, 50, 50, 400, 400);

      const logo = new Image();
      logo.src = "/favicon.png";

      logo.onload = () => {
        const logoSize = 90;
        const x = size / 2 - logoSize / 2;
        const y = size / 2 - logoSize / 2;

        ctx.fillStyle = "#ffffff";
        ctx.fillRect(x - 12, y - 12, logoSize + 24, logoSize + 24);

        ctx.drawImage(logo, x, y, logoSize, logoSize);

        const link = document.createElement("a");
        link.download = "qkiere-qr.png";
        link.href = canvas.toDataURL("image/png");
        link.click();
      };
    };
  };

  return (
    <div className="flex flex-col items-center gap-4">
      <div
        ref={qrRef}
        className="relative bg-white p-6 rounded-2xl shadow-lg border"
        style={{ width: 220, height: 220 }}
      >
        <QRCode
          value={value}
          size={180}
          bgColor="#ffffff"
          fgColor="#000000"
          level="H"
        />

        <div className="absolute inset-0 flex items-center justify-center">
          <div className="bg-white p-2 rounded-xl shadow">
            <img
              src="/favicon.png"
              alt="Qkiere"
              className="w-12 h-12 object-contain"
            />
          </div>
        </div>
      </div>

      <button
        onClick={downloadQR}
        className="px-4 py-2 bg-supernova-500 text-white rounded-xl hover:bg-supernova-600 transition"
      >
        Descargar QR
      </button>
    </div>
  );
}
